var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4541 6.16969H2.38075V3.79469H14.4541L12.3386 1.6792L14.0178 0L19 4.98219L14.0178 9.96439L12.3386 8.28519L14.4541 6.16969ZM6.66139 10.7148L4.98219 9.03561L0 14.0178L4.98219 19L6.66139 17.3208L4.5459 15.2053H15.7401V12.8303H4.5459L6.66139 10.7148Z",
    fill: "#30C6C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareContactIcon);
export default __webpack_public_path__ + "static/media/Share Contact Icon.99c99b1f2e3cbd7ca9dc12d6b73ec743.svg";
export { ForwardRef as ReactComponent };